import { Pipe, PipeTransform } from '@angular/core';
import { snakeCase } from 'lodash-es';

/** v8 ignore: Angular decorator metadata creates false-positive uncovered branches in v8 coverage. */
/* v8 ignore start */
@Pipe({
  name: 'snakeCase',
  standalone: true
})
export class SnakeCasePipe implements PipeTransform {
  /* v8 ignore stop */
  /** Converts a string to snake_case. */
  public transform(value?: string): string {
    if (!value) return '';
    return snakeCase(value);
  }
}
